import {
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import styled from 'styled-components';

export const StyledHeading = styled(Typography)`
  font-weight: bold;
  font-size: 20px;
  line-height: 47px;
  color: #3D454B;
  text-align:center;
`;

export const StyledGrayText = styled(Typography)`
  font-weight: 500;
  font-size: 14px;
  line-height: 15px;
  text-align: center;
  color: #9E9E9E;
  margin-top:10px;
`;

export const StyledOl = styled.ul`
  padding-inline-start: 20px;

  li {
    font-weight: 400;
    font-size: 16px;
    line-height: 1.3;
    color: #F9FAFB;
    &:not(:last-child) {
      margin-bottom:10px;
    }
  }
`;

export const RestrictionBlock = styled(Box)`
  border-bottom: 1px solid #344054;
  padding-bottom: 32px;
  width: 100%;
`;
